<template>
    <div>
        <page-header pageTitle="CONFIG_CLICK_SIGN.INDEX_TITLE"/>
        <div>
            <div class="config-clicksign-empty-warning" v-if="notCadastred">
                <span class="config-clicksign-empty-warning__icon">
                    <i class="icon-info"></i>
                </span>
                <div>
                    <strong>Nenhuma configuração cadastrada</strong>
                    <small>Esta empresa ainda não possui configuração de assinatura eletrônica. Preencha o formulário abaixo e salve para criar a primeira.</small>
                </div>
            </div>
            <SectionCardComponent
                    eyebrow="Geral"
                    title="Configurações Gerais"
                    subtitle="Responsável pela empresa, token de acesso, prazos de expiração e mensagem de solicitação de assinatura."
                    icon="icon-settings">
                <div class="row gutters">
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                        <div class="form-group">
                            <label class="required">{{ t('CONFIG_CLICK_SIGN.RESPONSIBLE') }}:</label>
                            <Select2 id="responsible" v-model="iten.responsible_id"
                                     :placeholder="iten.responsible_name"
                                     @select="selectResponsible"
                                     v-if="iten.responsible_name" :disabled="isView"
                                     :settings="ajaxPerson"></Select2>
                            <Select2 id="responsible" v-model="iten.responsible_id" placeholder="Selecione"
                                     v-else :disabled="isView" @select="selectResponsible"
                                     :settings="ajaxPerson"></Select2>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                        <div class="form-group">
                            <label class="required">Token de Acesso:</label>
                            <input type="text" class="form-control" :disabled="isView" v-model="iten.access_token">
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6">
                        <div class="form-group">
                            <label for="deadline_to_signature"
                                   class="required">{{ t('CONFIG_CLICK_SIGN.DEADLINE_TO_SIGNATURE') }} Proposta</label>
                            <input type="number" class="form-control" id="deadline_to_signature"
                                   placeholder="Dias para expiração" max="30"
                                   @keyup="checkMaxNumber('deadline_to_signature')"
                                   v-model="iten.deadline_to_signature" :disabled="isView">
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6">
                        <div class="form-group">
                            <label for="contract_deadline_to_signature"
                                   class="required">{{ t('CONFIG_CLICK_SIGN.DEADLINE_TO_SIGNATURE') }} Contrato</label>
                            <input type="number" class="form-control" id="contract_deadline_to_signature"
                                   placeholder="Dias para expiração" max="30"
                                   @keyup="checkMaxNumber('contract_deadline_to_signature')"
                                   v-model="iten.contract_deadline_to_signature" :disabled="isView">
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group">
                            <label for="exampleFormControlTextarea1" :class="isEdit? 'required': ''">Mensagem de
                                Solicitação de Assinatura</label>
                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                                      v-model="iten.message"
                                      placeholder="Para concluir nossa negociação, por favor leia atentamente e assine o documento que estamos encaminhando."
                                      :disabled="isView"></textarea>
                        </div>
                    </div>
                </div>
            </SectionCardComponent>
            <SectionCardComponent
                    eyebrow="Proposta"
                    title="Autenticação dos Signatários da proposta"
                    subtitle="Defina como cada signatário da proposta será autenticado e quais validações de identidade serão exigidas."
                    icon="icon-file-text">
                <div class="row gutters">
                    <div class="col-xl-6 col-lg-6 col-12" v-for="(configP, key) in signer_configs_proposal"
                         :key="key">
                        <div class="signer-config-card">
                            <div class="signer-config-card__header">
                                <span class="signer-config-card__icon"><i class="icon-user"></i></span>
                                <h6>{{ getNameAssing(configP.signer_type) }}</h6>
                            </div>
                            <div class="row gutters">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" v-if="configP.signer_type === 'seller'">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               id="proposal_seller_sign"
                                               v-model="iten.proposal_seller_sign" :disabled="isView">
                                        <label class="custom-control-label"
                                               for="proposal_seller_sign">
                                            {{ t('CONFIG_CLICK_SIGN.SIGN') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" v-if="configP.signer_type === 'witness'">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               id="proposal_witness_sign"
                                               v-model="iten.proposal_witness_sign" :disabled="isView">
                                        <label class="custom-control-label"
                                               for="proposal_witness_sign">
                                            {{ t('CONFIG_CLICK_SIGN.SIGN') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" v-if="configP.signer_type === 'manager'">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               id="proposal_manager_sign"
                                               v-model="iten.proposal_manager_sign" :disabled="isView">
                                        <label class="custom-control-label"
                                               for="proposal_manager_sign">
                                            {{ t('CONFIG_CLICK_SIGN.SIGN') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" v-if="configP.signer_type === 'sign'">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               id="proposal_spouse_sign"
                                               v-model="iten.proposal_spouse_sign" :disabled="isView">
                                        <label class="custom-control-label"
                                               for="proposal_spouse_sign">
                                            {{ t('CONFIG_CLICK_SIGN.SIGN') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" v-if="configP.signer_type === 'broker'">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               id="realtor_sign"
                                               v-model="iten.realtor_sign" :disabled="isView">
                                        <label class="custom-control-label"
                                               for="realtor_sign">
                                            {{ t('CONFIG_CLICK_SIGN.SIGN') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               :id="`proposal_selfie_enabled_${key}`"
                                               v-model="configP.selfie_enabled"
                                               :disabled="isView || configP.auths === 'icp_brasil'">
                                        <label class="custom-control-label"
                                               :for="`proposal_selfie_enabled_${key}`">{{
                                                t('CONFIG_CLICK_SIGN.SELFIE_ENABLED')
                                            }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               :id="`proposal_handwritten_enabled_${key}`"
                                               v-model="configP.handwritten_enabled"
                                               :disabled="isView || configP.auths === 'icp_brasil'">
                                        <label class="custom-control-label"
                                               :for="`proposal_handwritten_enabled_${key}`">{{
                                                t('CONFIG_CLICK_SIGN.HANDWIRITTEN_ENABLED')
                                            }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               :id="`proposal_official_document_enabled_${key}`"
                                               v-model="configP.official_document_enabled"
                                               :disabled="isView || configP.auths === 'icp_brasil'">
                                        <label class="custom-control-label"
                                               :for="`proposal_official_document_enabled_${key}`">{{
                                                t('CONFIG_CLICK_SIGN.OFFICIAL_DOCUMENT_ENABLED')
                                            }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               :id="`proposal_liveness_enabled_${key}`"
                                               v-model="configP.liveness_enabled"
                                               :disabled="isView || configP.auths === 'icp_brasil'">
                                        <label class="custom-control-label"
                                               :for="`proposal_liveness_enabled_${key}`">{{
                                                t('CONFIG_CLICK_SIGN.LIVENESS_ENABLED')
                                            }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group signer-config-card__auth">
                                        <label>{{ t('CONFIG_CLICK_SIGN.AUTHS') }}</label>
                                        <Select2 v-model="configP.auths" placeholder="Selecione"
                                                 v-if="['seller', 'witness'].includes(configP.signer_type)"
                                                 :options="[{id: 'email', text: 'E-mail'},{id: 'icp_brasil', text: 'ICP-Brasil'},...optionZap]"
                                                 :disabled="isView || !['seller', 'witness'].includes(configP.signer_type)"
                                                 @select="changeAuth(key, 'proposal')"
                                                 :settings="{width:'100%'}"></Select2>
                                        <Select2 v-model="configP.auths" placeholder="Selecione"
                                                 v-else
                                                 :options="[{id: 'email', text: 'E-mail'},...optionZap]"
                                                 :disabled="isView"
                                                 @select="changeAuth(key, 'proposal')"
                                                 :settings="{width:'100%'}"></Select2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </SectionCardComponent>
            <SectionCardComponent
                    eyebrow="Contrato"
                    title="Autenticação dos Signatários do contrato"
                    subtitle="Defina como cada signatário do contrato será autenticado e quais validações de identidade serão exigidas."
                    icon="icon-recent_actors">
                <div class="row gutters">
                    <div class="col-xl-6 col-lg-6 col-12" v-for="(configC, key) in signer_configs_contract"
                         :key="key">
                        <div class="signer-config-card">
                            <div class="signer-config-card__header">
                                <span class="signer-config-card__icon"><i class="icon-user"></i></span>
                                <h6>{{ getNameAssing(configC.signer_type) }}</h6>
                            </div>
                            <div class="row gutters">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" v-if="configC.signer_type === 'seller'">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               id="contract_seller_sign"
                                               v-model="iten.contract_seller_sign" :disabled="isView">
                                        <label class="custom-control-label"
                                               for="contract_seller_sign">
                                            {{ t('CONFIG_CLICK_SIGN.SIGN') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" v-if="configC.signer_type === 'witness'">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               id="contract_witness_sign"
                                               v-model="iten.contract_witness_sign" :disabled="isView">
                                        <label class="custom-control-label"
                                               for="contract_witness_sign">
                                            {{ t('CONFIG_CLICK_SIGN.SIGN') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" v-if="configC.signer_type === 'manager'">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               id="contract_manager_sign"
                                               v-model="iten.contract_manager_sign" :disabled="isView">
                                        <label class="custom-control-label"
                                               for="contract_manager_sign">
                                            {{ t('CONFIG_CLICK_SIGN.SIGN') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" v-if="configC.signer_type === 'sign'">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               id="contract_spouse_sign"
                                               v-model="iten.contract_spouse_sign" :disabled="isView">
                                        <label class="custom-control-label"
                                               for="contract_spouse_sign">
                                            {{ t('CONFIG_CLICK_SIGN.SIGN') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" v-if="configC.signer_type === 'broker'">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               id="contract_realtor_sign"
                                               v-model="iten.contract_realtor_sign" :disabled="isView">
                                        <label class="custom-control-label"
                                               for="contract_realtor_sign">
                                            {{ t('CONFIG_CLICK_SIGN.SIGN') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               :id="`contract_selfie_enabled_${key}`"
                                               v-model="configC.selfie_enabled"
                                               :disabled="isView || configC.auths === 'icp_brasil'">
                                        <label class="custom-control-label"
                                               :for="`contract_selfie_enabled_${key}`">{{
                                                t('CONFIG_CLICK_SIGN.SELFIE_ENABLED')
                                            }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               :id="`contract_handwritten_enabled_${key}`"
                                               v-model="configC.handwritten_enabled"
                                               :disabled="isView || configC.auths === 'icp_brasil'">
                                        <label class="custom-control-label"
                                               :for="`contract_handwritten_enabled_${key}`">{{
                                                t('CONFIG_CLICK_SIGN.HANDWIRITTEN_ENABLED')
                                            }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               :id="`contract_official_document_enabled_${key}`"
                                               v-model="configC.official_document_enabled"
                                               :disabled="isView || configC.auths === 'icp_brasil'">
                                        <label class="custom-control-label"
                                               :for="`contract_official_document_enabled_${key}`">{{
                                                t('CONFIG_CLICK_SIGN.OFFICIAL_DOCUMENT_ENABLED')
                                            }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               :id="`contract_liveness_enabled_${key}`"
                                               v-model="configC.liveness_enabled"
                                               :disabled="isView || configC.auths === 'icp_brasil'">
                                        <label class="custom-control-label"
                                               :for="`contract_liveness_enabled_${key}`">{{
                                                t('CONFIG_CLICK_SIGN.LIVENESS_ENABLED')
                                            }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group signer-config-card__auth">
                                        <label>{{ t('CONFIG_CLICK_SIGN.AUTHS') }}</label>
                                        <Select2 v-model="configC.auths" placeholder="Selecione"
                                                 v-if="['seller', 'witness'].includes(configC.signer_type)"
                                                 :options="[{id: 'email', text: 'E-mail'},{id: 'icp_brasil', text: 'ICP-Brasil'}, ...optionZap]"
                                                 :disabled="isView || !['seller', 'witness'].includes(configC.signer_type)"
                                                 @select="changeAuth(key, 'contract')"
                                                 :settings="{width:'100%'}"></Select2>
                                        <Select2 v-model="configC.auths" placeholder="Selecione"
                                                 v-else
                                                 :options="[{id: 'email', text: 'E-mail'}, ...optionZap]"
                                                 :disabled="isView"
                                                 @select="changeAuth(key, 'contract')"
                                                 :settings="{width:'100%'}"></Select2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </SectionCardComponent>
            <div class="card p-2 d-flex">
                <div class=" text-right" v-if="canSaveConfig">
                    <button class="btn btn-primary" type="button" @click="createConfig">
                        {{ t('GENERAL.SAVE') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pageHeader from '../../components/layouts/pageHeader';
import ConfigClickSign from '../../services/ConfigClickSign';
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import Select2 from 'vue3-select2-component';
import SectionCardComponent from '../../components/layouts/SectionCardComponent';

export default {
    name: "indexConfigClickSignComponent",
    components: {
        pageHeader,
        Select2,
        SectionCardComponent,
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            notCadastred: false,
            itenId: null,
            isView: false,
            isEdit: false,
            iten: {
                deadline_to_signature: 1,
                access_token: '2f66d437-88a2-410b-a077-abbba3d677d7',
                contract_deadline_to_signature: 1,
                contract_realtor_sign: false,
                realtor_sign: false,
            },
            ajaxPerson: {
                width: '100%',
                language: {
                    inputTooShort: function () {
                        return "Por favor, insira ao menos 1 caracteres para pesquisar.";
                    },
                    noResults: function () {
                        return "Nenhum resultado encontrado!";
                    }
                },
                minimumInputLength: 1,
                ajax: {
                    url: `${process.env.VUE_APP_BACK_END}/api/v1/clientes/list`,
                    dataType: "json",
                    headers: {
                        'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                        'company-id': localStorage.getItem('companyId'),
                    },
                    data: params => {
                        return {
                            term: params.term,
                        };
                    },
                    processResults: function (data) {
                        if (!(data.validations)) {
                            data.unshift({id: 0, text: "Nenhum"});
                            return {
                                results: data.map((i) => ({id: i.id, text: i.name}))
                            };
                        } else {
                            return {results: {id: 0, text: "Nenhum"}};
                        }
                    },
                    cache: true
                },
                initSelection: function (element, callback) {
                    callback({id: 1, text: 'initSelection test'});
                },
            },
            signer_configs_contract: [
                {
                    "signer_type": "seller",
                    "document_type": "contract",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "buyer",
                    "document_type": "contract",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "witness",
                    "document_type": "contract",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "manager",
                    "document_type": "contract",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "sign",
                    "document_type": "contract",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "broker",
                    "document_type": "contract",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                }
            ],
            signer_configs_proposal: [
                {
                    "signer_type": "seller",
                    "document_type": "business_proposals",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "buyer",
                    "document_type": "business_proposals",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "witness",
                    "document_type": "business_proposals",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "manager",
                    "document_type": "business_proposals",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "sign",
                    "document_type": "business_proposals",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "broker",
                    "document_type": "business_proposals",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                }
            ],
            optionsSignerType: [
                {id: "seller", text: "Vendedor"},
                {id: "buyer", text: "Comprador"},
                {id: "witness", text: "Testemunhas"},
                {id: "manager", text: "Gerente/Coordenador"},
                {id: "sign", text: "Cônjuge"},
                {id: "broker", text: "Corretor"},
            ],
            optionZap: [],
        }
    },
    computed: {
        canSaveConfig() {
            return this.isEdit
                    ? this.$hasPermission('ConfigClickSign_update')
                    : this.$hasPermission('ConfigClickSign_create');
        }
    },
    mounted() {
        this.$canAccess('ConfigClickSign_index');
        if (localStorage.getItem('companyId') && ['4d45d80c-829c-4013-80a6-b0d036012b59', 'ca8ecad3-9e79-4bce-965c-1d7ed59361f0'].includes(localStorage.getItem('companyId'))) {
            this.optionZap = [{id: 'whatsapp', text: 'Whatsapp'}]
        }
        this.index();
    },
    methods: {
        index() {
            this.itenId = null;
            this.isEdit = false;
            this.isView = false;
            this.notCadastred = false;
            this.$store.commit('changeLoading', true);
            ConfigClickSign.index().then((resp) => {
                if (resp?.data?.data?.length && resp?.data?.data[0]?.id) {
                    this.isEdit = true;
                    this.itenId = resp?.data?.data[0]?.id
                    ConfigClickSign.view(this.itenId).then((resp) => {
                        this.iten = resp.data;
                        this.signer_configs_contract = resp.data.signer_configs?.filter(i => i.document_type === 'contract')
                        this.signer_configs_proposal = resp.data.signer_configs?.filter(i => i.document_type === 'business_proposals')
                        this.$store.commit('changeLoading', false);
                    }).catch(() => {
                        this.$store.commit('changeLoading', false);
                    })
                } else {
                    this.notCadastred = true;
                    this.$store.commit('changeLoading', false);
                }
            }).catch(() => {
                this.$store.commit('changeLoading', false);
            })
        },
        selectResponsible({text}) {
            this.iten.responsible_name = text;
        },
        createConfig() {
            if (!this.iten.responsible_id) {
                this.toast.error('Preencha todos os campos obrigatórios');
                return;
            }
            this.$store.commit('changeLoading', true);
            this.iten.signer_configs = [...this.signer_configs_contract, ...this.signer_configs_proposal];
            if (this.isEdit) {
                if (!this.iten.deadline_to_signature || !this.iten.message?.length) {
                    this.toast.error('Preencha todos os campos obrigatórios');
                    this.$store.commit('changeLoading', false);
                    return;
                }
                ConfigClickSign.edit(this.iten).then(() => {
                    this.toast.success('Configuração editada com sucesso!');
                    this.index();
                }).catch(err => {
                    this.$store.commit('changeLoading', false);
                    this.errorMsg(err);
                })
                return;
            }
            this.iten.company_id = localStorage.getItem('companyId');
            !this.iten?.deadline_to_signature && delete this.iten.deadline_to_signature;
            !this.iten?.message && delete this.iten.message;
            ConfigClickSign.create(this.iten).then(() => {
                this.toast.success('Configuração criada com sucesso!');
                this.index();
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            })
        },
        getNameAssing(type) {
            return this.optionsSignerType.find((i) => i.id === type)?.text
        },
        changeAuth(key, context) {
            if (context === 'proposal' && this.signer_configs_proposal[key].auths === 'icp_brasil') {
                this.signer_configs_proposal[key].selfie_enabled = false;
                this.signer_configs_proposal[key].handwritten_enabled = false;
                this.signer_configs_proposal[key].official_document_enabled = false;
                this.signer_configs_proposal[key].liveness_enabled = false;
            } else if (context === 'contract' && this.signer_configs_contract[key].auths === 'icp_brasil') {
                this.signer_configs_contract[key].selfie_enabled = false;
                this.signer_configs_contract[key].handwritten_enabled = false;
                this.signer_configs_contract[key].official_document_enabled = false;
                this.signer_configs_contract[key].liveness_enabled = false;
            }
        },
        checkMaxNumber(field) {
            if (this.iten[field] > 30) {
                this.iten[field] = 30;
            } else if (this.iten[field] <= 0) {
                this.iten[field] = 1;
            }
        }
    }
}
</script>

<style scoped>
.config-clicksign-empty-warning {
    align-items: center;
    background: #fffaf0;
    border: 1px dashed #efd6a8;
    border-radius: 12px;
    display: flex;
    gap: 0.75rem;
    margin-bottom: 0.9rem;
    padding: 0.85rem 1rem;
}

.config-clicksign-empty-warning__icon {
    align-items: center;
    background: #fff7e6;
    border-radius: 10px;
    color: #a15c07;
    display: inline-flex;
    flex: 0 0 32px;
    height: 32px;
    justify-content: center;
    width: 32px;
}

.config-clicksign-empty-warning strong {
    color: #7c4a06;
    display: block;
    font-size: 0.86rem;
    font-weight: 800;
}

.config-clicksign-empty-warning small {
    color: #a15c07;
    display: block;
    font-size: 0.78rem;
}

:global(html.dark-theme .config-clicksign-empty-warning) {
    background: rgba(15, 23, 42, 0.24) !important;
    border-color: rgba(245, 158, 11, 0.16) !important;
}

:global(html.dark-theme .config-clicksign-empty-warning__icon) {
    background: rgba(245, 158, 11, 0.13) !important;
    color: #fcd34d !important;
}

:global(html.dark-theme .config-clicksign-empty-warning strong) {
    color: #fcd34d !important;
}

:global(html.dark-theme .config-clicksign-empty-warning small) {
    color: rgba(252, 211, 93, 0.78) !important;
}

.signer-config-card {
    background: #f8fbfa;
    border: 1px solid #dcebe7;
    border-radius: 12px;
    margin-bottom: 0.6rem;
    padding: 0.65rem 0.75rem 0.15rem;
}

.signer-config-card__header {
    align-items: center;
    border-bottom: 1px solid rgba(14, 94, 78, 0.12);
    display: flex;
    gap: 0.55rem;
    margin-bottom: 0.6rem;
    padding-bottom: 0.45rem;
}

.signer-config-card__header h6 {
    color: #173b34;
    font-size: 0.88rem;
    font-weight: 800;
    margin-bottom: 0;
}

.signer-config-card__icon {
    align-items: center;
    background: #e7f4f0;
    border-radius: 10px;
    color: #0e5e4e;
    display: inline-flex;
    flex: 0 0 28px;
    height: 28px;
    justify-content: center;
    width: 28px;
}

.signer-config-card .custom-control-label {
    color: #163f36;
    cursor: pointer;
    font-size: 0.78rem;
    font-weight: 700;
    line-height: 1.25rem;
}

.signer-config-card__auth {
    margin-bottom: 0.4rem;
}

.signer-config-card__auth label {
    color: #173b34;
    font-size: 0.78rem;
    font-weight: 800;
}

:global(html.dark-theme .signer-config-card) {
    background: rgba(15, 23, 42, 0.28);
    border-color: rgba(94, 234, 212, 0.14);
}

:global(html.dark-theme .signer-config-card__header) {
    border-bottom-color: rgba(94, 234, 212, 0.14);
}

:global(html.dark-theme .signer-config-card__header h6),
:global(html.dark-theme .signer-config-card__auth label) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .signer-config-card__icon) {
    background: var(--dark-primary-soft);
    color: #5eead4 !important;
}

:global(html.dark-theme .signer-config-card .custom-control-label) {
    color: var(--dark-text) !important;
}
</style>
